var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-col",
    [
      _c("el-button", {
        staticStyle: { "margin-bottom": "10px" },
        attrs: { icon: "el-icon-plus", circle: "", size: "mini" },
        on: { click: _vm.addLine },
      }),
      _c(
        "div",
        { staticStyle: { "max-height": "50vh", "overflow-y": "auto" } },
        _vm._l(_vm.lineArr, function (item, index) {
          return _c(
            "el-row",
            { key: index, staticClass: "line-item" },
            [
              _c(
                "el-col",
                { attrs: { span: 4 } },
                [
                  _c("el-input", {
                    staticClass: "value-item",
                    staticStyle: { width: "90% !important" },
                    attrs: {
                      placeholder: _vm.$t("chart.name"),
                      size: "mini",
                      clearable: "",
                    },
                    on: { change: _vm.changeAssistLine },
                    model: {
                      value: item.name,
                      callback: function ($$v) {
                        _vm.$set(item, "name", $$v)
                      },
                      expression: "item.name",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 4 } },
                [
                  _c(
                    "el-select",
                    {
                      staticClass: "select-item",
                      attrs: { size: "mini" },
                      on: { change: _vm.changeAssistLine },
                      model: {
                        value: item.field,
                        callback: function ($$v) {
                          _vm.$set(item, "field", $$v)
                        },
                        expression: "item.field",
                      },
                    },
                    _vm._l(_vm.fieldOptions, function (opt) {
                      return _c("el-option", {
                        key: opt.value,
                        attrs: { label: opt.label, value: opt.value },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              item.field === "0"
                ? _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c("el-input", {
                        staticClass: "value-item",
                        attrs: {
                          placeholder: _vm.$t("chart.drag_block_label_value"),
                          size: "mini",
                          clearable: "",
                        },
                        on: { change: _vm.changeAssistLine },
                        model: {
                          value: item.value,
                          callback: function ($$v) {
                            _vm.$set(item, "value", $$v)
                          },
                          expression: "item.value",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              item.field === "1"
                ? _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "el-select",
                        {
                          staticClass: "select-item",
                          attrs: {
                            size: "mini",
                            placeholder: _vm.$t("chart.field"),
                          },
                          on: {
                            change: function ($event) {
                              return _vm.changeAssistLineField(item)
                            },
                          },
                          model: {
                            value: item.fieldId,
                            callback: function ($$v) {
                              _vm.$set(item, "fieldId", $$v)
                            },
                            expression: "item.fieldId",
                          },
                        },
                        _vm._l(_vm.quotaData, function (quota) {
                          return _c(
                            "el-option",
                            {
                              key: quota.id,
                              attrs: { label: quota.name, value: quota.id },
                            },
                            [
                              _c(
                                "span",
                                { staticStyle: { float: "left" } },
                                [
                                  quota.deType === 0
                                    ? _c("svg-icon", {
                                        staticClass: "field-icon-text",
                                        attrs: { "icon-class": "field_text" },
                                      })
                                    : _vm._e(),
                                  quota.deType === 1
                                    ? _c("svg-icon", {
                                        staticClass: "field-icon-time",
                                        attrs: { "icon-class": "field_time" },
                                      })
                                    : _vm._e(),
                                  quota.deType === 2 || quota.deType === 3
                                    ? _c("svg-icon", {
                                        staticClass: "field-icon-value",
                                        attrs: { "icon-class": "field_value" },
                                      })
                                    : _vm._e(),
                                  quota.deType === 5
                                    ? _c("svg-icon", {
                                        staticClass: "field-icon-location",
                                        attrs: {
                                          "icon-class": "field_location",
                                        },
                                      })
                                    : _vm._e(),
                                ],
                                1
                              ),
                              _c(
                                "span",
                                {
                                  staticStyle: {
                                    float: "left",
                                    color: "#8492a6",
                                    "font-size": "12px",
                                  },
                                },
                                [_vm._v(_vm._s(quota.name))]
                              ),
                            ]
                          )
                        }),
                        1
                      ),
                      _c(
                        "el-select",
                        {
                          staticClass: "select-item",
                          staticStyle: { "margin-left": "10px" },
                          attrs: {
                            size: "mini",
                            placeholder: _vm.$t("chart.aggregation"),
                          },
                          on: { change: _vm.changeAssistLine },
                          model: {
                            value: item.summary,
                            callback: function ($$v) {
                              _vm.$set(item, "summary", $$v)
                            },
                            expression: "item.summary",
                          },
                        },
                        [
                          _c("el-option", {
                            key: "avg",
                            attrs: { value: "avg", label: _vm.$t("chart.avg") },
                          }),
                          _c("el-option", {
                            key: "max",
                            attrs: { value: "max", label: _vm.$t("chart.max") },
                          }),
                          _c("el-option", {
                            key: "min",
                            attrs: { value: "min", label: _vm.$t("chart.min") },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "el-col",
                { attrs: { span: 3 } },
                [
                  _c(
                    "el-select",
                    {
                      staticClass: "select-item",
                      staticStyle: { "margin-left": "10px" },
                      attrs: {
                        size: "mini",
                        placeholder: _vm.$t("chart.text_fontsize"),
                      },
                      on: { change: _vm.changeAssistLine },
                      model: {
                        value: item.fontSize,
                        callback: function ($$v) {
                          _vm.$set(item, "fontSize", $$v)
                        },
                        expression: "item.fontSize",
                      },
                    },
                    _vm._l(_vm.fontSize, function (option) {
                      return _c("el-option", {
                        key: option.value,
                        attrs: { label: option.name, value: option.value },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 3 } },
                [
                  _c(
                    "el-select",
                    {
                      staticClass: "select-item",
                      attrs: { size: "mini" },
                      on: { change: _vm.changeAssistLine },
                      model: {
                        value: item.lineType,
                        callback: function ($$v) {
                          _vm.$set(item, "lineType", $$v)
                        },
                        expression: "item.lineType",
                      },
                    },
                    _vm._l(_vm.lineOptions, function (opt) {
                      return _c("el-option", {
                        key: opt.value,
                        attrs: { label: opt.label, value: opt.value },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { staticStyle: { "text-align": "center" }, attrs: { span: 1 } },
                [
                  _c("el-color-picker", {
                    staticClass: "color-picker-style",
                    attrs: { predefine: _vm.predefineColors },
                    on: { change: _vm.changeAssistLine },
                    model: {
                      value: item.color,
                      callback: function ($$v) {
                        _vm.$set(item, "color", $$v)
                      },
                      expression: "item.color",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 1 } },
                [
                  _c("el-button", {
                    staticStyle: { float: "right" },
                    attrs: { type: "text", icon: "el-icon-delete", circle: "" },
                    on: {
                      click: function ($event) {
                        return _vm.removeLine(index)
                      },
                    },
                  }),
                ],
                1
              ),
            ],
            1
          )
        }),
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }